import { render, staticRenderFns } from "./homePageServices.vue?vue&type=template&id=66b60e96&"
import script from "./homePageServices.vue?vue&type=script&lang=js&"
export * from "./homePageServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports